import React from 'react'
import LogoImage from '../assets/mattilsynet_logo_high.png'

const Header = () => {
	return (
		<header>
			<div className='header-restrictor'>
				<img src={LogoImage} />
				<p className='slogan'>
				Statens tilsyn for 
				planter, fisk, dyr og 
				næringsmidler</p>
			</div>
		</header>
	)
}

export default Header